import { Button, DataSource, Layout, Panel, Table } from "@mcleod/components";

export abstract class AutogenLayoutProspectActionList extends Layout {
    buttonAddAction: Button;
    panelSecondaryFilters: Panel;
    sourceProspectAction: DataSource;
    tableActivities: Table;
}
